const intialStateUIControls = {
  // DOCS: Top Green Progress Bar related indicators
  showHorizontalProgressBar: false,
  horizontalProgressBarProgress: 0,

  // DOCS: This is used to show the modal to quit the onboarding journey
  inJourneyQuitModalOpen: false,

  // DOCS: Logout Modal Popup
  showLogoutPopupModal: false,
  showSessionExpiredModal: false,

  globalOverlayLoader: false,
  isSideDrawerOpen: false, // DOCS: When we open the side drawer as the z-index is normally 10 it pops over sidedrawer

  onlyCrossIcon: false, // DOCS: On Welcome Screen / Ack screen we DONT need to render progress bar, only the close icon on mobile is reqd
  postpanackscreen: false,
  // DOCS: Left Sidenav related indicators
  completeProfileRoute: '/dashboard',
  convUiStepsDetails: [
    { stepName: 'Personal Details', completionStatus: 'ACTIVE' },
    { stepName: 'Limit Approved', completionStatus: 'INACTIVE' },
    { stepName: 'KYC Details', completionStatus: 'INACTIVE' },
  ],
};

export default intialStateUIControls;
